import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import Scenario from "../components/scenario/Scenario";
import Schedule from "../components/schedule/Schedule";

const SchedulePage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "زمان بندی",
      slug: "planning/schedule",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          <Schedule />
        </div>
    </HelmetProvider>
  );
};

export default SchedulePage;
